module.exports = __webpack_public_path__ + "img/camp06_close.cdc7621f.png";